import React, { useState } from 'react';
import { TextField, IconButton, Box } from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  inputContainer: {
    display: 'flex',
    gap: theme.spacing(1),
    padding: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  textField: {
    flex: 1,
  },
  sendButton: {
    color: theme.palette.primary.main,
  },
}));

type Props = {
  onSend: (question: string) => void;
  disabled: boolean;
  placeholder?: string;
};

export const QuestionInput = ({ onSend, disabled, placeholder }: Props) => {
  const classes = useStyles();
  const [question, setQuestion] = useState<string>('');

  const handleSend = () => {
    if (question.trim()) {
      onSend(question);
      setQuestion('');
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <Box className={classes.inputContainer}>
      <TextField
        className={classes.textField}
        value={question}
        onChange={e => setQuestion(e.target.value)}
        onKeyPress={handleKeyPress}
        placeholder={placeholder || 'Ask a question...'}
        disabled={disabled}
        multiline
        maxRows={4}
        variant="outlined"
        size="small"
      />
      <IconButton
        className={classes.sendButton}
        onClick={handleSend}
        disabled={disabled || !question.trim()}
        aria-label="send"
      >
        <SendIcon />
      </IconButton>
    </Box>
  );
};

